function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Private_end_user"
}, /*#__PURE__*/React.createElement("title", null, "VF_private_end_user_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 122.1L141.7 47.9 0 122.1l13.2 25 14.8-7.7v94.2h227.5v-94.2l14.7 7.7 13.3-25zm-56.4 83.2H56.4v-80.8l85.3-44.7 85.3 44.7.1 80.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.4 129.9c-.1 5.5 1.5 11 4.7 15.5-16.4 5.8-25.9 18.1-25.9 35v11h99.2v-11c0-16.9-9.5-29.2-25.9-35 3.2-4.5 4.8-10 4.7-15.5 0-15.8-11.1-26-28.4-26s-28.4 10.2-28.4 26zm63.6 47.3h-70.5c1.1-8.2 7.3-21.3 35.2-21.3s34.1 13.1 35.3 21.3zm-35.2-59.1c6.5 0 14.2 2 14.2 11.8s-7.7 11.8-14.2 11.8-14.2-2-14.2-11.8 7.7-11.8 14.2-11.8z"
}))));